<form *ngIf="investsByUsers; else loader" [formGroup]="selectForm" (ngSubmit)="getProjects()">
    <mat-form-field>
        <mat-label>{{ 'reports.compare.select.shortLabel' | translate }}</mat-label>
        <mat-select formControlName="invest">
            <!-- <mat-option *ngFor="let invest of invests" [value]="invest.code">
                {{ invest.text.shortLabel }}
            </mat-option> -->
            <mat-optgroup *ngFor="let user of investsByUsers" [label]="user.username">
                <mat-option *ngFor="let invest of user.investments" [value]="invest.code">
                    {{ invest.text.shortLabel }}
                </mat-option>
            </mat-optgroup>
        </mat-select>
    </mat-form-field>
    <button mat-raised-button color="accent" type="submit" [disabled]="!selectForm.valid">
        {{ 'parameters.originSelector.form.submit.shortLabel' | translate }}
    </button>
</form>
<ng-template #loader>
    <mat-spinner [diameter]="35" color="accent" class="spinner"></mat-spinner>
</ng-template>
